module.exports = require("lodash/slice");